/* eslint-disable prefer-destructuring */
/* eslint-disable class-methods-use-this */
import binaryRegion from "../browsers/Pulsar/helpers/binarySearch/binaryRegion";

function comp(item, x, defaultVal) {
  if (!item?.length) return defaultVal;
  if (x < item[0]) return x - item[0];
  if (x > item[1]) return x - item[1];
  return 0;
}

class TrackerArea {
  constructor(start = 0, end = 0, preventMerge = false) {
    this.initStart = start;
    this.initEnd = end;
    this.areas = [];
    this.areasStartSort = [];
    this.preventMerge = preventMerge;
    this.reset();
  }

  reset() {
    this.areas = [];
    this.areasStartSort = [];
    if (this.initStart !== this.initEnd) {
      this.addArea(this.initStart, this.initEnd);
    }
  }

  mergeOverlappingAreas(areas = []) {
    if (!areas || !areas.length) return [];
    const arr = areas.sort((a, b) => a[0] - b[0]);
    const result = arr.slice(0, 1);
    for (let i = 1; i < arr.length; i++) {
      const a = arr[i];
      const prev = result[result.length - 1];
      if (a[0] > prev[1]) {
        result.push(a);
      } else if (a[0] <= prev[1] && a[1] >= prev[1]) {
        prev[1] = a[1];
      }
    }
    return result;
  }

  addAreaNoMerge(start, end) {
    if (start < end) {
      this.areas.push([start, end]);
    }
  }

  hasOverlap(start, end) {
    const arr = this.areas;
    const x1init = binaryRegion(arr, start, comp);
    const x1 = Math.max(0, x1init - 1);
    for (let i = x1; i < arr.length; i++) {
      if (!(arr[i][1] < start || arr[i][0] > end)) return true;
      if (arr[i][0] > end) return false;
    }
    return false;
  }

  mergeAll() {
    this.areas = this.mergeOverlappingAreas(this.areas);
  }

  addArea(start, end) {
    if (start < end) {
      const areas = [...this.areas, [start, end]];
      if (this.preventMerge) {
        this.areas = areas;
      } else {
        this.areas = this.mergeOverlappingAreas(areas);
      }
    }
  }

  removeArea(start, end) {
    const areas = this.areas
      .map((x) => this.findAreaDifference(x, start, end))
      .map(({ left, right }) => [left, right]);

    this.areas = []
      .concat(...areas)
      .filter(Boolean)
      .sort((a, b) => a[0] - b[0]);
  }

  findAreaDifference(target, y0, y1) {
    const noOverlap = target[1] < y0 || target[0] > y1;
    if (noOverlap) return { right: target };
    const left = target[0] < y0 ? [target[0], y0] : null;
    const right = target[1] > y1 ? [y1, target[1]] : null;
    return { left, right };
  }

  findNovelAreas(target, ind = 0) {
    const area = this.areas[ind];
    if (this.areas.length === ind) return [target];
    if (area[0] > target[1]) return [target];
    const [y0, y1] = area;
    const { left, right } = this.findAreaDifference(target, y0, y1);
    const restRights = right ? this.findNovelAreas(right, ind + 1) : [];
    return [left, ...restRights].filter(Boolean).filter((x) => x[0] < x[1]);
  }
}

export default TrackerArea;
